import React from 'react';
import { formatPhoneForDisplay } from '../../Utils/phoneFormat';

export { parsePhoneParts, formatPhoneForDisplay } from '../../Utils/phoneFormat';

export default function FormattedPhone({ countryCode, phoneNumber, phone, className = '' }) {
  const formatted = formatPhoneForDisplay({ countryCode, phoneNumber, phone });
  const rootClass = ['formatted-phone', className].filter(Boolean).join(' ');

  if (!formatted.full) {
    return <span className={className || undefined}>—</span>;
  }

  if (!formatted.countryCode) {
    return (
      <span className={rootClass}>
        <span className="formatted-phone-number">{formatted.national}</span>
      </span>
    );
  }

  return (
    <span className={rootClass}>
      <span className="formatted-phone-code">{formatted.countryCode}</span>
      <span className="formatted-phone-number">{formatted.national}</span>
    </span>
  );
}
